import { useGetTemplateById } from "@/api/template.api";
import { useParams } from "react-router";
import { TemplateEditor } from "../template-editor/template-editor";

export const EditTemplate = () => {
    const { templateId } = useParams();
    const { data: template } = useGetTemplateById(templateId ? Number(templateId) : undefined);

    if (!template) {
        return null;
    }

    return <TemplateEditor template={template} isCreate={false} key={JSON.stringify(template)} />;
};
